<template>
    <el-dialog v-dialogDrag class="selDialog" width="1100px"
               :visible.sync="dialogVisible"
               append-to-body
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                物资选择
            </div>
        </div>
        <div class="dialog_body">
            <div style="padding: 10px;height: 40px;margin-bottom:20px">
                <searchBar :searchData="searchData" @search="search">
                </searchBar>
            </div>
            <el-divider content-position="center">物资列表/库存列表</el-divider>
            <el-row :gutter="20">
                <el-col :span="20">
                    <el-table
                            ref="table"
                            :data="dataList"
                            height="300"
                            style="width: 100%;"
                            highlight-current-row
                            :header-cell-style="headerStyle"
                            :cell-style="cellStyle"
                            @row-click="rowClick"
                            @select="rowClick"
                            row-key="id"
                            border>
                        <el-table-column
                                type="index"
                                :index="(pageInfo.page-1) * pageInfo.pagesize+1"
                                label="序号"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="typeName"
                                label="物资类别">
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                label="物资编码"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                prop="proName"
                                width="150"
                                label="物资名称">
                        </el-table-column>
                        <el-table-column
                                prop="units"
                                width="100"
                                label="计量单位">
                        </el-table-column>
                        <el-table-column
                                prop="specification"
                                width="100"
                                label="规格型号">
                        </el-table-column>
                        <el-table-column
                                prop="minSalePrice"
                                width="100"
                                label="最低销售价">
                        </el-table-column>
                        <el-table-column
                                prop="costPrice01"
                                width="100"
                                label="成本价">
                        </el-table-column>
                        <el-table-column
                                prop="origin"
                                width="100"
                                label="产地">
                        </el-table-column>
                        <el-table-column
                                prop="color"
                                width="100"
                                label="颜色">
                        </el-table-column>
                    </el-table>
                    <div class="pagStyle">
                        <pagination :pageInfo="pageInfo" @toPage="toPage"></pagination>
                    </div>
                </el-col>
                <el-col :span="4">
                    <el-table
                            ref="table_kc"
                            :data="dataList_kc"
                            height="300"
                            style="width: 100%;"
                            highlight-current-row
                            :header-cell-style="headerStyle"
                            :cell-style="cellStyle"
                            row-key="id"
                            border>
                        <el-table-column
                                prop="warehouseNo"
                                width="70"
                                label="仓号">
                        </el-table-column>
                        <el-table-column
                                prop="endNum"
                                width="100"
                                label="库存数量">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>

            <el-divider content-position="center">已选物资列表</el-divider>
            <el-table
                    ref="tableSelected"
                    :data="dataListSelected"
                    height="200"
                    style="width: 100%;"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    border>
                <el-table-column
                        width="100"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-delete"
                                   @click.native.prevent="deleteRow(scope.$index, dataListSelected)"
                                   type="danger"
                                   size="small">
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        type="selection"
                        prop="_dx"
                        label="选择"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="typeName"
                        label="物资类别">
                </el-table-column>
                <el-table-column
                        prop="proCode"
                        label="物资编码"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="proName"
                        width="150"
                        label="物资名称">
                </el-table-column>
                <el-table-column
                        prop="units"
                        width="100"
                        label="计量单位">
                </el-table-column>
                <el-table-column
                        prop="specification"
                        width="100"
                        label="规格型号">
                </el-table-column>
                <el-table-column
                        prop="minSalePrice"
                        width="100"
                        label="最低销售价">
                </el-table-column>
                <el-table-column
                        prop="costPrice01"
                        width="100"
                        label="成本价">
                </el-table-column>
                <el-table-column
                        prop="origin"
                        width="100"
                        label="产地">
                </el-table-column>
                <el-table-column
                        prop="color"
                        width="100"
                        label="颜色">
                </el-table-column>
            </el-table>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="primary" @click="submit">确 定</el-button>
                <el-button type="danger" @click="close">取 消</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import searchBar from '@/components/tools/toolBar/searchBar/build'
    import pagination from "@/components/tools/table/pagination";

    export default {
        name: "selRole",
        props: ['selId'],
        components: {
            searchBar, pagination
        },
        data() {
            return {
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "关键字搜索",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },
                dataList_kc: [],
                productInfoId: "",
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },
                dialogVisible: true,
                dialoading: false,
                dataList: [],
                dataListSelected: [],
            }
        },
        async mounted() {
            await this.getListData();
            if (this.warehouseId) {
                this.defaultSelect();
            }
        },
        methods: {
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            async search() {
                this.pageInfo.page = 1;
                await this.getListData();
            },
            async getKcListData() {
                this.dialoading = true;
                let param = {
                    url: "/proinventorydetail/getByProuductInfoId",
                    param: {
                        productInfoId: this.productInfoId
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList_kc = data.data.data;
                }
                this.dialoading = false;
            },
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/productinfo/listSel",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page,
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.data;
                }
                this.dialoading = false;
            },
            rowClick(row) {
                this.productInfoId = row.productInfoId;

                let selRows = this.$refs.table.selection;

                let index = selRows.findIndex(item => {
                    return row == item;
                })
                if (index < 0)
                    this.$refs.table.toggleRowSelection(row, true);
                else
                    this.$refs.table.toggleRowSelection(row, false);

                selRows.map(item => {
                    if (item.productInfoId != undefined && item.productInfoId != null && item.productInfoId != '') {
                        let hasId = false;
                        for (let i = 0; i < this.dataListSelected.length; i++) {
                            if (this.dataListSelected[i].productInfoId == item.productInfoId) {
                                hasId = true;
                                break;
                            }
                        }
                        if (!hasId) {
                            this.dataListSelected.push(item);
                        }
                    }
                })

                this.getKcListData();
            },
            submit() {
                //let selRows = this.$refs.table.selection;
                if (this.dataListSelected.length <= 0) {
                    this.$message({message: '请选择需要添加的物资信息', type: 'error'});
                    return false;
                }
                this.$emit("checkRow", this.dataListSelected);
            },
            //默认选中
            defaultSelect() {
                this.$nextTick(() => {
                    let selrow = this.dataList.find(item => {
                        return item.productInfoId == this.productInfoId
                    })
                    this.$refs.table.setCurrentRow(selrow);
                });
            },
            toPage() {
                this.getListData();
            },
        },
    }
</script>

